function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M626.4,3870.9c-174.2-55.5-310.1-160.8-407.7-313.9c-126.3-197.2-118.7,24.9-118.7-3449.1c0-2823.2,3.8-3162,30.6-3255.8c61.2-206.7,210.5-380.9,407.7-474.7l107.2-49.8H5000h4354.4l107.2,49.8c197.2,93.8,346.5,268,407.7,474.7c26.8,93.8,30.6,432.6,30.6,3255.8c0,2823.2-3.8,3162-30.6,3255.8c-61.3,206.7-210.5,380.9-407.7,474.7l-107.2,49.8l-4325.7,3.8C1577.7,3893.8,687.7,3890,626.4,3870.9z M2550.1,107.9v-3428l-913,5.7l-914.9,5.7l-72.7,44c-38.3,24.9-95.7,86.1-124.4,134l-51.7,90V107.9v3148.6l51.7,88c53.6,90,118.7,145.5,204.8,170.3c26.8,9.6,447.9,17.2,936,17.2l884.3,1.9V107.9z M4904.3,107.9v-3426.1H3822.9H2741.5V107.9V3534h1081.4h1081.4V107.9z M7258.6,107.9v-3426.1H6177.2H5095.8V107.9V3534h1081.4h1081.4V107.9z M9327.7,3490c55.5-30.6,103.4-76.6,141.7-137.8l57.4-91.9V109.8v-3150.5l-51.7-90c-28.7-47.9-86.1-109.1-124.4-134l-72.7-44l-913-5.7l-914.9-5.7v3428V3534h895.8h897.7L9327.7,3490z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.4,2701.4v-411.5h641.2h641.2v411.5v411.5h-641.2H827.4V2701.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.4,1466.8v-421.1l637.4,3.8l635.5,5.7v411.5v411.5l-635.5,5.7l-637.4,3.8V1466.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.4,232.3v-411.5h641.2h641.2v411.5v411.5h-641.2H827.4V232.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3181.7,2701.4v-411.5h641.2h641.2v411.5v411.5h-641.2h-641.2V2701.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3189.4,1863c-3.8-13.4-5.7-201-3.8-415.4l5.7-392.4l637.4-5.7l635.5-3.8v421.1v421.1h-631.6C3336.7,1887.9,3197,1882.2,3189.4,1863z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3181.7,232.3v-411.5h641.2h641.2v411.5v411.5h-641.2h-641.2V232.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5555.1,2701.4v-411.5h641.2h641.2v411.5v411.5h-641.2h-641.2V2701.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5555.1,1466.8v-421.1l637.4,3.8l635.5,5.7v411.5v411.5l-635.5,5.7l-637.4,3.8V1466.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7913.2,2707.1l5.7-407.7l637.4-5.7l635.5-3.8v411.5v411.5h-641.2h-641.2L7913.2,2707.1z"
})));

function SvgKanban(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/kanban.ba9834bf.svg";
export { ForwardRef as ReactComponent };